module.exports = __webpack_public_path__ + "assets/img/addCard.80bf5d7f.png";